import { ArrowLeft } from 'lucide-react'

/**
 * "← Lists" above a list's detail and the Shortlist, as one button. It used
 * to be an `IconButton` with the word beside it as plain text, so a tap on
 * "Lists" — which reads as part of the same control — did nothing
 * (UI-audit a2-19). The arrow keeps its 44px square and the word sits where
 * it did; the button is simply both of them.
 */
export function BackToLists({ onBack }: { onBack: () => void }) {
  return (
    <div className="lists-backbar">
      <button type="button" className="lists-backbtn" aria-label="Back to Lists" onClick={onBack}>
        <span className="lists-backbtn__icon" aria-hidden="true"><ArrowLeft size={20} /></span>
        <span className="lists-backbar__label">Lists</span>
      </button>
    </div>
  )
}
